import Decimal from 'decimal.js';

import { toBN } from '@utils/formaters.utils';

import { AssetToken, AssetTokenBase } from '@app-types/common/token.types';

export const arrayFromN = (N: number) =>
  N > 0 ? new Array(N).fill(0).map((_, index) => index) : [];

export const getTotalValueByKey = <T extends Record<string, any>>(
  array: T[],
  key: keyof T,
): Decimal => array.reduce((acc, item) => acc.plus(toBN(item[key])), toBN(0));

export const mapToAssetTokenBase = (tokens: AssetToken[]): AssetTokenBase[] =>
  tokens.map((item) => ({
    address: item.address,
    assetType: item.assetType,
    tokenId: item.tokenId ?? null,
  }));
